import React from 'react';

import { cn } from '@/lib/utils';

import { Tooltip } from './tooltip';

type ChipProps = {
	children: React.ReactNode;
	color?: string;
	className?: string;
	tooltip?: string;
};

export default function Chip({ children, color, className, tooltip }: ChipProps) {
	const bgColor = color ? `${color}15` : '#f3f4f6'; // 15 is hex for ~8% opacity
	const textColor = color || '#6b7280'; // gray-600 as default

	const chipElement = (
		<span
			className={cn('inline-flex items-center rounded-sm px-2 py-1 text-xs font-medium', className)}
			style={{
				backgroundColor: bgColor,
				color: textColor,
			}}
		>
			{children}
		</span>
	);

	if (tooltip) {
		return <Tooltip content={tooltip}>{chipElement}</Tooltip>;
	}

	return chipElement;
}
